import React, { useEffect, useState } from 'react'

export const useSearch = (APIData, searchValue) => {
    const [searchInput, setSearchInput] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);

    const searchItems = () => {
        setSearchInput(searchValue)
        const filteredData = APIData?.filter((item) => {
            return Object.values(item).join('').toLowerCase().includes(searchValue.toLowerCase())
        })
        setFilteredResults(filteredData)
    }

    useEffect(()=>{
    searchItems();
    },[searchValue])

    return {filteredResults}
}

